module.exports = __webpack_public_path__ + "img/Welcome.0cf84767.png";